import * as React from "react";
import C from "classnames";
export const CardImage = (props) => {
    return (React.createElement("img", { className: C(props.bottom && "card-img-bottom", props.top && "card-image-top", props.className), src: props.src, alt: props.alt, "data-testid": props.testId, height: props.height, width: props.width }));
};
//# sourceMappingURL=CardImage.js.map